import { render } from "./ModalMedPaidService.vue?vue&type=template&id=012149ee"
import script from "./ModalMedPaidService.vue?vue&type=script&lang=js"
export * from "./ModalMedPaidService.vue?vue&type=script&lang=js"

import "./ModalMedPaidService.vue?vue&type=style&index=0&id=012149ee&lang=css"

import exportComponent from "D:\\DEV\\Actual\\SanElita\\elita_web_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__